import { useState, ChangeEvent, MouseEvent, useEffect } from "react";
import {
  CommercialUserProps,
  CommerciaSignUpInput,
  CommerciaSignUpInputError,
} from "../../state/actionType";
import CreateCommercialUserForm from "./components/CreateCommercialUserForm";
import { connect, useSelector } from "react-redux";
import {
  checkForExistingCommercialUserByEmail,
  checkForExistingCommercialUserByMobile,
  fetchCommercialUserProfileById,
  updateCommercialUser
} from "../../state/action";
import ValidateForm from "./components/ValidateForm";

interface OwnProps {
  onClose: () => void;
  commercialUserData: CommercialUserProps;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & OwnProps & StateProps;
const HandleUpdateCommercialUser: React.FC<Props> = ({
  onClose,
  commercialUserData,
  onUpdateCommercialUser,
  fetchUserProfile,
  onFetchCommercialProfile,
  onCheckExistingEmail,
  onCheckExistingMobileNo,
}) => {
  const commercialProfile = fetchUserProfile.commercialUserProfile;
  const [formData, setFormData] = useState<CommerciaSignUpInput>({
    mobile_no: commercialUserData?.mobile_no,
    name: commercialProfile?.name,
    gender: commercialProfile?.gender,
    email: commercialUserData?.email,
  });
  const [error, setError] = useState<CommerciaSignUpInputError>({});
  const [apiError, setApiError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSubmit = async (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setSubmitted(true);

    setIsLoading(true);
    const signup_input: CommerciaSignUpInput = {
      name: formData.name,
      mobile_no: formData.mobile_no,
      email: formData.email,
      gender: formData.gender,
    };
    const userId = commercialUserData.id.toString();
    onUpdateCommercialUser(userId, signup_input);
    // onResetCommercialData()
    setIsLoading(false);
  };
  useEffect(() => {
    onFetchCommercialProfile(commercialUserData?.id.toString());
  }, [onFetchCommercialProfile]);
  return (
    <>
      <CreateCommercialUserForm
        header={"Update Commercial User"}
        loading={isLoading}
        formData={formData}
        error={error}
        handleChange={handleChange}
        onClose={onClose}
        handleSubmit={handleSubmit}
        isUpdate
      />
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    fetchUserProfile: state.commercialUser.commercialUserProfileState,
  };
};
const mapDispatchToProps = (dispatch: any) => ({
  onUpdateCommercialUser: (
    user_id: string,
    signup_input: CommerciaSignUpInput
  ) => dispatch(updateCommercialUser(user_id, signup_input)),
  onFetchCommercialProfile: (user_id: string) =>
    dispatch(fetchCommercialUserProfileById(user_id)),
  onCheckExistingMobileNo: (data: string) =>
    dispatch(checkForExistingCommercialUserByMobile(data)),
  onCheckExistingEmail: (data: string) =>
    dispatch(checkForExistingCommercialUserByEmail(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HandleUpdateCommercialUser);
